export class SortThreatHuntingScanRequestsBy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "ThreatHuntingScanRequestSortField",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "SortOrder",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SortThreatHuntingScanRequestsBy.attributeTypeMap;
    }
    constructor() {
    }
}
